export default {
  title: "Track shipment",
  description: "Shipping Tracking Page",
  env: "production",
  host: "//tracking.webinterpret.com",
  apiHost: "//api.tp.devwebinterpret.com/v1/tracking",
  glopalRedirectUrl: "https://tracking.glopal.com",
}



// WEBPACK FOOTER //
// ./src/core/config/index.js